
import React, { useEffect, useRef, useState, useReducer, useMemo, useCallback } from "react";
import {
	getAuthMobile,
	SARIconThemeColor,
	sendNotificationFirebaseRes,
	setMobileBackColor,
	setMobileButttonBackColor,
	setMobileCardBorderColor,
	setMobileCardColor,
	setMobileTextColor,
} from "../utility";
import { Container, Navbar } from "react-bootstrap";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";
import axios from "axios";
import Toast from "../common/toast";
import { useMutation, useQuery, useQueryClient } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
	Button, CircularProgress, MenuItem, TextField,
	Select, Dialog, DialogActions, DialogContent, DialogTitle,
	FormControl, InputLabel, Box, Slide, Badge, Typography, InputAdornment,
} from "@mui/material";
import {
	ApartmentOutlined, ArrowBackOutlined, Delete, DeleteOutline, DescriptionOutlined,
	EditLocationAltOutlined, FlagOutlined, HomeOutlined, HouseOutlined,
	LocalPostOffice, LocalPostOfficeOutlined, LocalShippingOutlined,
	LocationCity, LocationOnOutlined, PinDropOutlined, StairsOutlined,
	Title, TitleOutlined,
} from "@mui/icons-material";
import { Form, Formik } from "formik";
import Order from "../components/mobile screen/cart/order";
import { t } from "i18next";
import LoadingTreeDataDialog from "../components/mobile screen/mobileComponents/LoadingTreeDataDialog";
import stripe_image from "../images/stripe-payement-gateway-logos.png";
import urway_image from "../images/urway-payement-gateway-logos.png";
import BottomNavBar from "../components/BottomNavBar";
import LoginComponent from "../components/mobile screen/mobileComponents/loginComponent";
import DeliveryDialog from "../components/DeliveryDialog";
import CurrentLocationMap from "../components/map screens/CurrentLocationMap";
import NewLocationPicker from "../components/map screens/NewLocationPicker";
import { LoadingButton } from "@mui/lab";
import DeleteLocationDialog from "../components/DeleteLocationDialog";

// Custom hook for order type management
const useOrderType = (treeData, params) => {

	const initialActiveType = () => {
		if (treeData?.details?.is_delivery_active) {
			if (treeData?.details?.is_dinein_active) {
				if (params.get("t") && params.get("t") !== "null") {
					return "dinein";
				} else {
					return "delivery";
				}

			} else if (treeData?.details?.is_pickup_active) {
				return "pickup";
			} else {
				return "delivery";
			}
		} else if (treeData?.details?.is_dinein_active) {
			return "dinein";
		} else if (treeData?.details?.is_pickup_active) {
			return "pickup";
		}

	}

	const initialState = {
		isDineIn: (!params.get("t") || params.get("t") === "null") ? false : true,
		isPickup: false,
		isDelivery: (!params.get("t") || params.get("t") == "null") ? true : false,
		activeType: initialActiveType() || "dinein"
	};


	const [state, setState] = useState(initialState);

	const setActiveType = (type) => {
		setState(prev => ({
			isDineIn: type === "dinein",
			isPickup: type === "pickup",
			isDelivery: type === "delivery",
			activeType: type
		}));
	};

	return {
		...state,
		setActiveType
	};
};

// Custom hook for location management
const useLocationManagement = () => {
	const [mode, setMode] = useState(null);
	const [selectedPlace, setSelectedPlace] = useState(null);
	const [placeAddress, setPlaceAddress] = useState("");
	const [latLangVal, setLatLangVal] = useState(null);
	const [isEditDelivery, setIsEditDelivery] = useState(false);
	const [isProcessLoading, setIsProcessLoading] = useState(false);
	const [deleteLocationDialogOpen, setDeleteLocationDialogOpen] = useState(false);
	const [distanceBetween, setDistanceBetween] = useState(null);
	const [durationBetween, setDurationBetween] = useState(null);
	const [calcDeliveryFeesValue, setCalcDeliveryFeesValue] = useState(0);

	const initialLocationFormData = {
		title: "",
		street: "",
		unit_number: "",
		floor_number: "",
		apartment_number: "",
		description: "",
		latitude: "",
		longitude: "",
		suburb: "",
		city: "",
		province: "",
		state: "",
		postcode: "",
		country: ""
	};

	const [locationFormData, setLocationFormData] = useState(initialLocationFormData);

	const handleLocationFormInputChange = (e) => {
		setLocationFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const resetLocationForm = () => {
		setLocationFormData(initialLocationFormData);
		setLatLangVal(null);
		setIsEditDelivery(false);
	};

	return {
		mode,
		setMode,
		selectedPlace,
		setSelectedPlace,
		placeAddress,
		setPlaceAddress,
		latLangVal,
		setLatLangVal,
		isEditDelivery,
		setIsEditDelivery,
		isProcessLoading,
		setIsProcessLoading,
		deleteLocationDialogOpen,
		setDeleteLocationDialogOpen,
		distanceBetween,
		setDistanceBetween,
		durationBetween,
		setDurationBetween,
		calcDeliveryFeesValue,
		setCalcDeliveryFeesValue,
		locationFormData,
		setLocationFormData,
		handleLocationFormInputChange,
		resetLocationForm
	};
};

// Custom hook for cart persistence
const useCartPersistence = (tableQr) => {
	const storageKey = `cartState_${tableQr}`;

	const saveCartState = (state) => {
		try {
			localStorage.setItem(storageKey, JSON.stringify(state));
		} catch (error) {
			console.error("Error saving cart state:", error);
		}
	};

	const loadCartState = () => {
		try {
			const savedState = localStorage.getItem(storageKey);
			return savedState ? JSON.parse(savedState) : null;
		} catch (error) {
			console.error("Error loading cart state:", error);
			return null;
		}
	};

	const clearCartState = () => {
		localStorage.removeItem(storageKey);
	};

	return { saveCartState, loadCartState, clearCartState };
};

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const Cart = ({ tableQr, tableName }) => {
	const queryClient = useQueryClient();
	const navigate = useNavigate();
	const location = useLocation();
	const [params, setParams] = useSearchParams();
	const queryString = window.location.search;
	const urlParam = new URLSearchParams(queryString);
	const divRef = useRef(null);
	const [divWidth, setDivWidth] = useState(null);
	const [orderNote, setOrderNote] = useState("");

	// State management
	const [loadingTree, setLoadingTree] = useState(false);
	const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);
	const [openDialog, setOpenDialog] = useState(false);
	const [payment_method, setPaymentMethod] = useState("ONL");
	const [selectedGateway, setSelectedGateway] = useState("mada");
	const [gatewayImage, setGatewayImage] = useState(urway_image);
	const [toastSettings, setToastSettings] = useState({
		open: false,
		message: "",
		success: false,
	});
	const [timeZone, setTimeZone] = useState(localStorage.getItem("timezone") || "");
	const [formValues, setFormValues] = useState(null);
	const [formSubmitValues, setFormSubmitValues] = useState(null);
	const [isFromOrder, setIsFromOrder] = useState(false);

	const [allTreeData, setAllTreeData] = useState(() => {
		const savedTreeData = localStorage.getItem("tree_data");
		return savedTreeData ? JSON.parse(savedTreeData) : [];
	});

	const [confirmEmptyDialog, setConfirmEmptyDialog] = useState(false);


	// Custom hooks
	const {
		isDineIn: isDineInFlag,
		isPickup: isPickupFlag,
		isDelivery: isDeliveryFlag,
		activeType,
		setActiveType
	} = useOrderType(allTreeData, params);


	const {
		mode,
		setMode,
		selectedPlace,
		setSelectedPlace,
		placeAddress,
		setPlaceAddress,
		latLangVal,
		setLatLangVal,
		isEditDelivery,
		setIsEditDelivery,
		isProcessLoading,
		setIsProcessLoading,
		deleteLocationDialogOpen,
		setDeleteLocationDialogOpen,
		distanceBetween,
		setDistanceBetween,
		durationBetween,
		setDurationBetween,
		calcDeliveryFeesValue,
		setCalcDeliveryFeesValue,
		locationFormData,
		setLocationFormData,
		handleLocationFormInputChange,
		resetLocationForm
	} = useLocationManagement();

	const { saveCartState, loadCartState, clearCartState } = useCartPersistence(tableQr);

	const MobileToken = localStorage.getItem("mobileLoginToken");
	const lang = localStorage.getItem("lang");
	const check_login = MobileToken || null;
	const [deliveryDialogOpen, setDeliveryDialogOpen] = useState(false);
	const [openLocationFormDialog, setOpenLocationFormDialog] = useState(false);

	// Memoized values
	const currencySymbol = useMemo(() => allTreeData?.details?.currency_symbol || "", [allTreeData]);
	const isSA = useMemo(() => timeZone === "SA", [timeZone]);

	const [dialogOpen, setDialogOpen] = useState(false);
	// API calls
	const getTimeZone = async () => {
		try {
			const response = await axios.get(`${process.env.REACT_APP_API}/timezone`);
			if (response.status === 200) {
				const timezoneData = response?.data?.data?.timezone || "";
				localStorage.setItem("countryCode", JSON.stringify(response?.data?.data?.countryCode));
				localStorage.setItem("timezone", JSON.stringify(timezoneData));
				setTimeZone(response?.data?.data?.countryCode);
			}
		} catch (error) {
			console.error("Error fetching timezone:", error);
		}
	};

	const loadTree = async () => {
		setLoadingTree(true);
		try {
			const timeZone = localStorage.getItem("timezone") || "";
			const response = await axios.get(
				`${process.env.REACT_APP_API}/menus/${tableQr}/public-tree`,
				{
					headers: {
						localization: localStorage.getItem("lang") || "",
						timeZone: timeZone.replace(/["]+/g, ''),
					},
				}
			);

			if (!response?.data?.data?.details || !response?.data?.data?.tree || !response?.data?.data?.items) {
				setLoadingTreeDialog(true);
			}

			const treeData = response?.data?.data || [];
			setAllTreeData(treeData);
			localStorage.setItem("tree_data", JSON.stringify(treeData));
			return treeData;
		} catch (error) {
			console.error("Error loading tree:", error);
			handleOpenToast(t("Error loading menu data"), false);
		} finally {
			setLoadingTree(false);
		}
	};

	const loadTreeData = async () => {
		if (allTreeData.length === 0 || !allTreeData.details || !allTreeData.tree || !allTreeData.items) {
			await loadTree();
		} else {
			const pathSegments = location.pathname.split('/');
			const menu_code_number = pathSegments[2];
			const treeMenu_code_number = allTreeData?.details?.code_number;
			if (menu_code_number !== treeMenu_code_number) {
				await loadTree();
			}
		}
	};

	const {
		data: basketData,
		isLoading: basketIsLoading,
		refetch: refetchBasket
	} = useQuery(
		["basket-items", localStorage.getItem("lang")],
		async () => {
			const response = await axios.get(
				`${process.env.REACT_APP_API}/basket-items?menu_code=${tableQr}&token=${localStorage.getItem("gustToken")}`,
				{
					headers: {
						localization: localStorage.getItem("lang"),
					},
				}
			);
			if (response?.data?.data?.length == 0) {
				handleOpenToast(t("Your Cart is empty"), false);
				navigate(
					`/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get("t")}&lang=${lang}`
				);

			}
			return response;
		}
	);

	const {
		data: savedPlaces,
		isLoading: isLoadingSavedPlaces,
		refetch: refetchSavedPlaces
	} = useQuery(
		["saved-places"],
		async () => {
			const response = await axios.get(
				`${process.env.REACT_APP_API}/customer/addresses`,
				{
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${MobileToken}`,
					},
				}
			);
			return response.data.data;
		},
		{
			enabled: !!MobileToken,
			refetchOnWindowFocus: false,
			retry: 1,
		}
	);


	const handleSaveLocation = async () => {
		setIsProcessLoading(true);
		const newPlace = {
			...locationFormData,
			latitude: latLangVal?.lat + "",
			longitude: latLangVal?.lng + "",
		};

		const token = localStorage.getItem("mobileLoginToken");

		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/customer/addresses`,
				newPlace,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				handleOpenToast(t("Location has been added successfully"), true);
				handleCloseFormDialog();
				setLocationFormData({
					title: "",
					street: "",
					unit_number: "",
					floor_number: "",
					apartment_number: "",
					description: "",
					longitude: "",
					latitude: "",
					suburb: "",
					city: "",
					province: "",
					state: "",
					postcode: "",
					country: ""
				});
				refetchSavedPlaces();
				setLatLangVal(null);
				setIsEditDelivery(false);
			}
		} catch (error) {
			alert("Error saving location:", error);
			console.error("Error saving location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	const handleUpdateLocation = async () => {
		setIsProcessLoading(true);
		const token = localStorage.getItem("mobileLoginToken");
		try {
			const response = await axios.post(
				`${process.env.REACT_APP_API}/customer/addresses/${locationFormData.id}`,
				locationFormData,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				handleOpenToast(t("Location has been updated successfully"), true);
				handleCloseFormDialog();
				setLocationFormData({
					title: "",
					street: "",
					unit_number: "",
					floor_number: "",
					apartment_number: "",
					description: "",
					longitude: "",
					latitude: "",
					suburb: "",
					city: "",
					province: "",
					state: "",
					postcode: "",
					country: ""
				});
				refetchSavedPlaces();
				setLatLangVal(null);
				setIsEditDelivery(false);
			}
		} catch (error) {
			alert("Error updating location:", error);
			console.error("Error updating location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	const handleDeleteLocation = async () => {
		setIsProcessLoading(true);
		const token = localStorage.getItem("mobileLoginToken");
		try {
			const response = await axios.delete(
				`${process.env.REACT_APP_API}/customer/addresses/${selectedPlace.id}`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			);

			if (response.status === 200 || response.status === 201) {
				setMode(null);
				handleOpenToast(t("Location has been deleted successfully"), true);
				setLocationFormData({
					title: "",
					street: "",
					unit_number: "",
					floor_number: "",
					apartment_number: "",
					description: "",
					longitude: "",
					latitude: "",
					suburb: "",
					city: "",
					province: "",
					state: "",
					postcode: "",
					country: ""
				});
				refetchSavedPlaces();
				setDeleteLocationDialogOpen(false);

				setLatLangVal(null);
				setIsEditDelivery(false);
			}
		} catch (error) {
			alert("Error deleting location:", error);
			console.error("Error deleting location:", error);
		} finally {
			setIsProcessLoading(false);
		}
	};

	// Mutations
	const paymentFunction = async () => {
		const paymentParameters = {
			table: params.get("t") || "null" ? "" : params.get("t"),
			token: localStorage.getItem("gustToken"),
			amount: Number(basketData?.data?.data?.final_total) || 0,
			gateway: selectedGateway,
			notes: formValues?.note || "",
			address: formValues?.address || "",
			address_id: selectedPlace?.id || null,
			menu_code: tableQr || "",
			type: formValues?.type || activeType,
			distance: distanceBetween || 0,
			duration: durationBetween || 0,
			// delivery_fees:  Number(calcDeliveryFeesValue || 0) || 0
			delivery_fees: (formValues?.type === "delivery" || activeType === "delivery") ? Number(calcDeliveryFeesValue || 0) : 0

		};



		const { data: response } = await axios.post(
			`${process.env.REACT_APP_API}/orders-payment`,
			paymentParameters,
			getAuthMobile()
		);
		return response;
	};

	const { mutate: mutatePayment, isLoading: isLoadingMutatePayment } = useMutation(paymentFunction, {
		onSuccess: async (res) => {
			localStorage.setItem("amount", basketData?.data?.data?.final_total || 0);
			localStorage.setItem("currency", currencySymbol || "");
			params.set("payment_url", res?.data?.payment_url);
			setParams(params);
			window.open(res.data.payment_url, "_self");
		},
		onError: async () => {
			try {
				const response = await axios.get(
					`${process.env.REACT_APP_API}/check-token?token=${MobileToken}`,
					null
				);
				if (response.status === 200 && !response.data.data.is_token_active) {
					navigate(`/${tableName}/${tableQr}/menus?lang=${lang}`);
					localStorage.clear();
					localStorage.setItem("lang", lang);
				} else {
					handleOpenToast(t("Error While Saving The Changes"), false);
				}
			} catch (error) {
				handleOpenToast(t("Error While Saving The Changes"), false);
			}
		},
		onSettled: () => {
			queryClient.invalidateQueries("clientMobilePayment");
		},
	});

	const addItemFunction = async (values) => {
		if (payment_method === "ONL" && isSA) {
			setFormValues(values);
			openPaymentDialog();
			return "online";
		}

		const headers = {
			Authorization: `Bearer ${MobileToken}`,
			'Content-Type': 'application/json',
		};

		const response = await axios.post(
			`${process.env.REACT_APP_API}/orders`,
			{
				notes: values.note,
				address: values.address,
				menu_code: tableQr,
				token: localStorage.getItem("gustToken"),
				table: params.get("t"),
				address_id: selectedPlace?.id || null,
				pickup_venue: values.pickup_venue || "",
				type: values.type || activeType,
				distance: distanceBetween || 0,
				duration: durationBetween || 0,
				delivery_fees: (formValues?.type === "delivery" || activeType === "delivery") ? Number(calcDeliveryFeesValue || 0) : 0
			},
			{ headers }
		);
		return response.data;
	};

	const { mutate: muteOrder, isLoading: isLoadingOrder } = useMutation(addItemFunction, {
		onSuccess: async (res) => {
			if (res !== "online") {
				await sendNotificationFirebaseRes(allTreeData?.details, "New Order", "New order has been created", "orders");
				handleOpenToast(t("Order has been added successfully"), true);
				setTimeout(() => handleBack(), 1000);
				clearCartState(); // Clear saved state after successful order
			}
		},
		onError: (error) => {
			handleOpenToast(t(error.response?.data?.message || "Error processing order"), false);
		},
		onSettled: () => {
			queryClient.invalidateQueries("addOrder");
		},
	});

	const emptyOrderBasket = async () => {
		const { data: response } = await axios.post(
			`${process.env.REACT_APP_API}/empty-basket`,
			{
				menu_code: tableQr,
				token: localStorage.getItem("gustToken"),
			}
		);
		return response.data;
	};

	// Helper functions
	const handleGatewaySelect = (event) => {
		const gateway = event.target.value;
		setSelectedGateway(gateway);
		setGatewayImage(gateway === "stripe" ? stripe_image : urway_image);
	};

	const handleSelectedType = useCallback((handleOrderTypeField, orderType) => {
		setActiveType(orderType);
		handleOrderTypeField("type", orderType);

		if (orderType === "pickup" && allTreeData?.details?.pickup_venues?.length === 1) {
			handleOrderTypeField("pickup_venue", allTreeData.details.pickup_venues[0].id);
		} else if (orderType === "delivery") {
			if (!check_login) {
				handleOpenDialog(0);
			} else {
				setDeliveryDialogOpen(true);
			}
		}
	}, [allTreeData, check_login, setActiveType]);

	const handleOptionSelect = (option) => {
		setMode(option);
	};

	const updateLocationFormData = (pickupMapAddress) => {
		setLocationFormData(prev => ({
			...prev,
			unit_number: pickupMapAddress?.house_number || "",
			street: pickupMapAddress?.road || "",
			suburb: pickupMapAddress?.suburb || pickupMapAddress?.neighbourhood || "",
			city: pickupMapAddress?.city || pickupMapAddress?.town || pickupMapAddress?.village || "",
			province: pickupMapAddress?.state || "",
			state: pickupMapAddress?.state || "",
			postcode: pickupMapAddress?.postcode || "",
			country: pickupMapAddress?.country || ""
		}));
	};

	const getDistanceAndDuration = async (start, end) => {
		try {
			const url = `https://router.project-osrm.org/route/v1/driving/${start.lng},${start.lat};${end.lng},${end.lat}?overview=false`;
			const response = await axios.get(url);
			const data = response.data;

			const distanceInMeters = data.routes[0].distance;
			const durationInSeconds = data.routes[0].duration;

			return {
				distanceInMeters,
				durationInSeconds
			};
		} catch (error) {
			console.error('Error fetching distance and duration:', error);
			return null;
		}
	};

	const handleSelectPlace = async (place, is_edit) => {
		const venue_latitude = allTreeData?.details?.venue_latitude || 0;
		const venue_longitude = allTreeData?.details?.venue_longitude || 0;
		const selectedPlace_latitude = place?.latitude || 0;
		const selectedPlace_longitude = place?.longitude || 0;

		const distanceAndDuration = await getDistanceAndDuration(
			{ lat: venue_latitude, lng: venue_longitude },
			{ lat: selectedPlace_latitude, lng: selectedPlace_longitude }
		);


		if (distanceAndDuration) {
			const { distanceInMeters, durationInSeconds } = distanceAndDuration;
			const distanceInKm = (distanceInMeters / 1000).toFixed(2);
			const durationInMinutes = (durationInSeconds / 60).toFixed(2);

			if (distanceInKm > 20) {
				handleOpenToast(t("Selected location is too far (more than 20km). Please choose a closer location."), false);
				return;
			}

			await calcDeliveryFees(distanceInKm);
			setDistanceBetween(distanceInKm);
			setDurationBetween(durationInMinutes);
			setSelectedPlace({ ...place, distance: distanceInKm, duration: durationInMinutes });
		}

		else {
			handleOpenToast(t("Error while specifying the location"), false);
			return;
		}

		setLocationFormData(place || {});
		setIsEditDelivery(is_edit);

		const addressParts = [
			`${t("LocationName")} ${place.title || 'NAN'}`,
			`${t("Street")} ${place.street || 'NAN'}`,
			`${t("Unit No")} ${place.unit_number || 'NAN'}`,
			`${t("Floor No")} ${place.floor_number || 'NAN'}`,
			`${t("Apartment No")} ${place.apartment_number || 'NAN'}`
		];

		setPlaceAddress(addressParts.join(", "));

		if (!is_edit) {
			resetLocationForm();
			setDeliveryDialogOpen(false);
		}
	};

	const calcDeliveryFees = (distance) => {
		if (allTreeData?.details?.is_delivery_service_active) {
			setCalcDeliveryFeesValue(distance <= 10 ? 14 : Number(distance) + 4);
		} else {
			setCalcDeliveryFeesValue(allTreeData?.details?.delivery_fees || 0);
		}
	};

	const handleOpenDeleteLocationDialog = (place) => {
		setDeleteLocationDialogOpen(true);
		setSelectedPlace(place);
	};

	const handleCloseFormDialog = () => {
		setOpenLocationFormDialog(false);
		resetLocationForm();
	};

	const openPaymentDialog = () => {
		setOpenDialog(true);
	};

	const closePaymentDialog = () => {
		setOpenDialog(false);
	};

	const handlePayment = () => {
		mutatePayment();
		setOpenDialog(false);
	};

	const handleOpenDialog = (is_from_order) => {
		setIsFromOrder(is_from_order);
		setDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setDialogOpen(false);
	};

	const handleVerificationSuccess = (token) => {
		if (token) {
			localStorage.setItem("mobileLoginToken", token || "");
			if (isFromOrder && formSubmitValues) {
				if (allTreeData?.details?.order_ability) {
					muteOrder(formSubmitValues);
				} else {
					sendToWhatsApp(formSubmitValues, allTreeData?.details?.whatsapp);
				}
			} else {
				setDeliveryDialogOpen(true);
			}
		}
	};

	const handleBack = () => {
		// Save cart state before navigating away
		if (basketData?.data?.data) {
			saveCartState({
				orderType: activeType,
				payment_method,
				selectedGateway,
				selectedPlace,
				placeAddress,
				orderNote,
				distanceBetween,
				durationBetween,
				basketData: basketData.data.data,
				formValues: formValues || {},
			});
		}

		if (urlParam.get("section")) {
			navigate(
				`/${tableName}/${tableQr}/sections?section=${urlParam.get("section")}&t=${urlParam.get("t")}&lang=${lang}`
			);
		} else {
			navigate(
				`/${tableName}/${tableQr}/sections?section=0&t=${urlParam.get("t")}&lang=${lang}`
			);
		}
	};

	const handleSaveCartState = () => {
		if (basketData?.data?.data) {
			saveCartState({
				orderType: activeType,
				payment_method,
				selectedGateway,
				selectedPlace,
				placeAddress,
				orderNote,
				distanceBetween,
				durationBetween,
				basketData: basketData.data.data,
				formValues: formValues || {},
			});
		}
	}

	const onImageError = (e) => {
		e.target.src = coverSample;
	};

	const handleOpenToast = (message, state) => {
		setToastSettings({
			open: true,
			success: state,
			message: message
		});
	};

	const handleCloseToast = (event, reason) => {
		if (reason === "clickaway") return;
		setToastSettings({ open: false, message: "", success: false });
	};

	const sendToWhatsApp = (values, whatsapp_no) => {
		let message = `*${t("Order details")}:*\n`;
		message += `-----------------------\n\n`;

		// Order type information
		const orderType = values.type ||
			(allTreeData?.details?.is_dinein_active ? "dinein" :
				allTreeData?.details?.is_pickup_active ? "pickup" :
					allTreeData?.details?.is_delivery_active ? "delivery" : "");

		if (orderType) {
			message += `*${t("Type")} :* ${t(orderType)}\n`;

			if (orderType === "pickup") {
				const pickVenueItem = allTreeData?.details?.pickup_venues?.find(vitem => vitem.id === values.pickupVenue)?.name ||
					allTreeData?.details?.pickup_venues[0]?.name || "";
				message += values.pickupVenue ? `*${t("Pickup Venue")} :* ${t(pickVenueItem) || ""}\n` : "";
			}
		}

		// Address information
		message += values.address ? `*${t("Address")}:* ${values.address || ""}\n` : "";
		if (isDineInFlag) {
			message += values.table ? `*${t("Table")}:* ${values.table || ""}\n` : "";
		}

		// Items list
		message += `\n*${t("items")}:*\n`;
		values.items.forEach((item) => {
			message += `-${t(item?.name)} X ${item.quantity} X ${item.price} ${currencySymbol}\n`;
			if (item.notes) {
				message += `${item.notes || ""}\n`;
			}
			message += `\n`;
		});

		// Payment details
		message += `\n*${t("Payment details")}:*\n`;
		message += `${t("Subtotal")}: ${values.total} ${currencySymbol}\n`;
		message += `${t("Tax")}: ${values.tax} ${currencySymbol}\n`;

		if (values?.tax_admin > 0) {
			message += `${t("Admin tax")}: ${values.tax_admin} ${currencySymbol}\n`;
		}

		if (isDeliveryFlag) {
			message += `${t("Payment Method")}: ${values.payment_method}\n`;
			message += `${t("Delivery Fees")}: ${calcDeliveryFeesValue || 0} ${currencySymbol}\n`;
		}

		const finalTotal = isDeliveryFlag ?
			Number(values.final_total_without_delivery_fees) + Number(calcDeliveryFeesValue || 0) :
			Number(values.final_total_without_delivery_fees);

		message += `${t("Total")}: ${finalTotal} ${currencySymbol}\n`;
		message += `*${t("Total plus VAT")}*\n\n\n`;

		if (values.note) {
			message += `*${t("Note")} :* ${values.note || ""}\n`;
		}

		handleOpenToast(t("Order has been sent successfully"), true);
		emptyOrderBasket();
		setTimeout(() => handleBack(), 1000);

		const whatsappUrl = `https://api.whatsapp.com/send?phone=${whatsapp_no}&text=${encodeURIComponent(message)}`;
		window.open(whatsappUrl, "_blank");
		handleBack();
	};

	const handleSubmit = (values) => {
		setFormSubmitValues(values);

		// Check for delivery order with no selected place
		if (isDeliveryFlag && !selectedPlace) {
			handleOpenToast(t("Please select a delivery address first"), false);
			setDeliveryDialogOpen(true);
			return;
		}

		// Check if distance is more than 20km for delivery
		if (isDeliveryFlag && selectedPlace && selectedPlace.distance > 20) {
			handleOpenToast(t("Please select a location within 20km distance"), false);
			return;
		}

		if (MobileToken && MobileToken.length > 0) {
			if (allTreeData?.details?.order_ability) {
				muteOrder(values);
			} else if (allTreeData?.details?.whatsapp) {
				sendToWhatsApp(values, allTreeData.details.whatsapp);
			}
		} else {
			handleOpenDialog(1);
		}
	};

	// Effects
	useEffect(() => {
		getTimeZone();
		loadTreeData();
		window.scrollTo(0, 0);




		// Load saved cart state if exists
		const savedState = loadCartState();
		if (savedState) {
			setActiveType(savedState.orderType);
			setSelectedPlace(savedState.selectedPlace);
			setPlaceAddress(savedState.placeAddress);
			setSelectedGateway(savedState.selectedGateway || "mada");
			setPaymentMethod(savedState.payment_method || "Cash");
			setFormValues(savedState.formValues || {});
			calcDeliveryFees(savedState?.selectedPlace?.distance || 0);
			setDistanceBetween(savedState.distanceBetween || 0);
			setDurationBetween(savedState.durationBetween || 0);
			setOrderNote(savedState.orderNote || "");
		}


		if (isDeliveryFlag && !savedState?.selectedPlace) {
			if (!check_login) {
				handleOpenDialog(0);
			} else {
				setDeliveryDialogOpen(true);
			}


		}
	}, []);

	useEffect(() => {
		if (divRef.current) {
			const width = divRef.current.offsetWidth;
			setDivWidth(width);
		}
	}, [basketData]);

	if (basketIsLoading || loadingTree) {
		return <Loading backColor={setMobileBackColor()} />;
	}

	return (
		<div className={`min-vh-100`} style={{ backgroundColor: setMobileBackColor() }}>
			<ToastContainer />
			<Container fluid>
				<div style={{ marginBottom: 70 }} className="row">
					<div className="col-lg-8 d-none d-lg-block">
						<div className="mt-5 text-center d-flex-justify-content-center align-items-center">
							<div style={{ marginTop: "20%" }}>
								<img
									src={allTreeData?.details?.logo || no_image}
									className="me-4"
									style={{ width: "250px", height: "250px" }}
									onError={onImageError}
								/>
								<h1
									className="mt-4 head-font"
									style={{ color: setMobileTextColor() }}
								>
									{allTreeData?.details?.venu_name}
								</h1>
							</div>
						</div>
					</div>

					<div className="col-lg-4 ms-auto p-0">
						<div className="mobile-side-screen">
							<div>
								<div>
									<Navbar
										className={`d-flex justify-content-between align-items-center position-fixed top-0 z-2 mobile-nav `}
										style={{
											width: "100%",
											margin: "auto",
											backgroundColor: setMobileBackColor(),
										}}
									>
										<Button
											onClick={handleBack}
											style={{ color: setMobileTextColor() }}
										>
											<ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
										</Button>

										<Navbar.Brand className="text-center m-0">
											<p
												className="mb-1 text-center sub-font"
												style={{ color: setMobileTextColor() }}
											>
												{allTreeData?.details?.table}
											</p>
										</Navbar.Brand>
										<Button sx={{ color: setMobileTextColor() }}></Button>
									</Navbar>
								</div>
							</div>
							<div className="sections mx-2 alignByLang">
								<div style={{ marginTop: "60px", marginBottom: "24px" }}>
									<Formik
										onSubmit={handleSubmit}
										initialValues={basketData?.data.data || {}}
										enableReinitialize
									>
										{({ errors, setFieldValue, values }) => (
											<Form>
												{/* Order Type Selection */}
												<div
													className="head-font"
													style={{
														display: "flex",
														justifyContent: "center",
														backgroundColor: setMobileBackColor(),
														borderRadius: "12px",
														boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
														marginBottom: "24px",
														overflow: "hidden",
														border: `1px solid ${setMobileCardBorderColor()}`,
													}}
												>
													{allTreeData?.details?.is_dinein_active && (params.get("t") && params.get("t") !== "null") && (allTreeData?.details?.is_pickup_active || allTreeData?.details?.is_delivery_active) && (
														<button
															type="button"
															onClick={() => handleSelectedType(setFieldValue, "dinein")}
															className={`tab-button ${isDineInFlag ? "active" : ""}`}
															style={{
																flex: 1,
																padding: "14px 24px",
																border: "none",
																fontSize: "16px",
																fontWeight: 600,
																cursor: "pointer",
																transition: "all 0.3s ease",
																borderRight: `1px solid ${setMobileCardBorderColor()}`,
																borderColor: isDineInFlag ? setMobileButttonBackColor() : "transparent",
																borderWidth: isDineInFlag ? "0 0 3px 0" : "0",
																borderStyle: "solid",
																backgroundColor: isDineInFlag ? setMobileCardColor() : setMobileBackColor(),
																color: isDineInFlag ? setMobileButttonBackColor() : setMobileTextColor(),
															}}
														>
															{t("Dine-In")}
														</button>
													)}

													{allTreeData?.details?.is_pickup_active && (allTreeData?.details?.is_dinein_active || allTreeData?.details?.is_delivery_active) && (
														<button
															type="button"
															onClick={() => handleSelectedType(setFieldValue, "pickup")}
															className={`tab-button`}
															style={{
																flex: 1,
																padding: "14px 24px",
																border: "none",
																fontSize: "16px",
																fontWeight: 600,
																cursor: "pointer",
																transition: "all 0.3s ease",
																borderRight: allTreeData?.details?.is_delivery_active ? `1px solid ${setMobileCardBorderColor()}` : "none",
																borderColor: isPickupFlag ? setMobileButttonBackColor() : "transparent",
																borderWidth: isPickupFlag ? "0 0 3px 0" : "0",
																borderStyle: "solid",
																backgroundColor: isPickupFlag ? setMobileCardColor() : setMobileBackColor(),
																color: isPickupFlag ? setMobileButttonBackColor() : setMobileTextColor(),
															}}
														>
															{t("Pickup")}
														</button>
													)}

													{allTreeData?.details?.is_delivery_active && (allTreeData?.details?.is_pickup_active || allTreeData?.details?.is_dinein_active) && (
														<button
															type="button"
															onClick={() => handleSelectedType(setFieldValue, "delivery")}
															className={`tab-button ${isDeliveryFlag ? "active" : ""}`}
															style={{
																flex: 1,
																padding: "14px 24px",
																border: "none",
																fontSize: "16px",
																fontWeight: 600,
																cursor: "pointer",
																transition: "all 0.3s ease",
																borderColor: isDeliveryFlag ? setMobileButttonBackColor() : "transparent",
																borderWidth: isDeliveryFlag ? "0 0 3px 0" : "0",
																borderStyle: "solid",
																backgroundColor: isDeliveryFlag ? setMobileCardColor() : setMobileBackColor(),
																color: isDeliveryFlag ? setMobileButttonBackColor() : setMobileTextColor(),
															}}
														>
															{t("Delivery")}
														</button>
													)}
												</div>


												<Button
													className="w-100 head-font"

													onClick={() => setConfirmEmptyDialog(true)}
													style={{
														color: "#f44336",
														backgroundColor: "transparent",
														fontWeight: 600,
														fontSize: "14px",
														letterSpacing: "0.5px",
														border: "1px solid #f44336",
													}}
													startIcon={<DeleteOutline />}
												>
													{t("Empty Cart")}
												</Button>

												{/* Pickup Venue Section */}
												{isPickupFlag && allTreeData?.details?.is_pickup_active && (
													<div
														className="m-top-12 p-24 rounded-3 sub-font"
														style={{
															color: setMobileTextColor(),
															border: `1px solid ${setMobileCardBorderColor()}`,
															backgroundColor: setMobileCardColor(),
															padding: "24px",
															borderRadius: "12px",
															boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															marginBottom: "16px",
														}}
													>
														{allTreeData?.details?.pickup_venues?.length === 1 ? (
															<TextField
																id="pickupVenue"
																name="pickupVenue"
																label={<span className="sub-font">{t("Pickup Venue")}</span>}
																value={allTreeData?.details?.pickup_venues[0]?.name}
																className="form-control rounded-2 sub-font"
																size="small"
																sx={{
																	backgroundColor: setMobileCardColor(),
																	minWidth: 300,
																	marginTop: "12px",
																	"& .MuiOutlinedInput-root": {
																		borderRadius: "8px",
																	},
																	"& .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileCardBorderColor(),
																	},
																	"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileButttonBackColor(),
																	},
																	"& .MuiInputBase-input": {
																		color: setMobileTextColor() || "#333",
																		fontFamily:
																			localStorage.getItem("lang") === "ar" ||
																				localStorage.getItem("lang") === "fa"
																				? "Almarai"
																				: "Roboto, sans-serif",
																		fontWeight: 500,
																		letterSpacing: "0.5px",
																	},
																	"& .MuiInputLabel-root": {
																		color: setMobileTextColor() || "#555",
																		fontWeight: 500,
																	},
																	"& .MuiInputLabel-root.Mui-focused": {
																		color: setMobileButttonBackColor(),
																	},
																}}
															/>
														) : (
															<TextField
																select
																id="pickupVenue"
																required={isPickupFlag}
																name="pickupVenue"
																label={<span className="sub-font">{t("Select Pickup Venue")}</span>}
																value={values.pickupVenue}
																onChange={(e) => setFieldValue("pickupVenue", e.target.value)}
																className="form-control rounded-2 sub-font"
																size="small"
																sx={{
																	backgroundColor: setMobileCardColor(),
																	minWidth: 300,
																	marginTop: "12px",
																	"& .MuiOutlinedInput-root": {
																		borderRadius: "8px",
																	},
																	"& .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileCardBorderColor(),
																	},
																	"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileButttonBackColor(),
																	},
																	"& .MuiInputBase-input": {
																		color: setMobileTextColor() || "#333",
																		fontFamily:
																			localStorage.getItem("lang") === "ar" ||
																				localStorage.getItem("lang") === "fa"
																				? "Almarai"
																				: "Roboto, sans-serif",
																		fontWeight: 500,
																		letterSpacing: "0.5px",
																	},
																	"& .MuiInputLabel-root": {
																		color: setMobileTextColor() || "#555",
																		fontWeight: 500,
																	},
																	"& .MuiInputLabel-root.Mui-focused": {
																		color: setMobileButttonBackColor(),
																	},
																}}
															>
																{allTreeData?.details?.pickup_venues?.map((venue) => (
																	<MenuItem
																		className="sub-font"
																		key={venue.id}
																		value={venue.id}
																		sx={{
																			color: setMobileTextColor() || "#333",
																			fontFamily:
																				localStorage.getItem("lang") === "ar" ||
																					localStorage.getItem("lang") === "fa"
																					? "Almarai"
																					: "Roboto, sans-serif",
																			fontWeight: 500,
																			"&:hover": {
																				backgroundColor: setMobileButttonBackColor() + "20",
																			},
																		}}
																	>
																		{venue.name}
																	</MenuItem>
																))}
															</TextField>
														)}
													</div>
												)}

												{/* Delivery Address Section */}
												{isDeliveryFlag && (
													<>
														<div
															className="m-top-12 p-24 rounded-3 alignByLang sub-font"
															style={{
																border: `1px solid ${setMobileCardBorderColor()}`,
																backgroundColor: setMobileCardColor(),
																borderRadius: "12px",
																boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
																marginBottom: "16px",
															}}
															ref={divRef}
														>
															<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
																<label
																	htmlFor="address"
																	className="font-size-14 mb-1 sub-font"
																	style={{
																		color: setMobileTextColor(),
																		marginTop: "16px",
																		fontWeight: 500,
																	}}
																>
																	<LocalShippingOutlined
																		className={`${localStorage.getItem("lang") === "ar" || localStorage.getItem("lang") === "fa" ? "ms-2" : "me-2"}`}
																		fontSize="large"
																		style={{
																			color: setMobileButttonBackColor(),
																			verticalAlign: "middle",
																		}}
																	/>{" "}
																	{t("Address")}
																</label>

																<Box
																	component="div"
																	onClick={() => setDeliveryDialogOpen(true)}
																	sx={{
																		mt: 2,
																		mb: 2,
																		ml: 2,
																		px: 2,
																		py: 1,
																		display: "flex",
																		alignItems: "center",
																		backgroundColor: setMobileButttonBackColor() + '10',
																		borderRadius: "20px",
																		cursor: "pointer",
																		maxWidth: "80%",
																		border: `1px solid ${setMobileCardBorderColor()}`,
																		transition: "all 0.2s ease",
																		'&:hover': {
																			backgroundColor: setMobileButttonBackColor() + '20',
																		}
																	}}
																>
																	<EditLocationAltOutlined
																		sx={{
																			mr: 1,
																			color: setMobileButttonBackColor(),
																		}}
																		fontSize="small"
																	/>
																	<Typography
																		variant="body2"
																		className="sub-font"
																		sx={{
																			color: setMobileTextColor(),
																			overflow: "hidden",
																			textOverflow: "ellipsis",
																			whiteSpace: "nowrap",
																			fontWeight: 500,
																		}}
																	>
																		{selectedPlace?.title || placeAddress || t("Select Delivery Location")}
																	</Typography>
																</Box>

															</div>

															<TextField
																id="address"
																name="address"
																type="address"
																required={isDeliveryFlag}
																variant="outlined"
																value={values.address || placeAddress || ""}
																onChange={(e) => setFieldValue("address", e.target.value)}
																placeholder={t("Address description")}
																helperText={errors.address && errors.address}
																className="form-control rounded-2 sub-font"
																error={errors.address}
																size="small"
																sx={{
																	backgroundColor: setMobileCardColor(),
																	border: `1px solid ${setMobileCardBorderColor()}`,
																	minWidth: 300,
																	marginTop: "12px",
																	"& .MuiOutlinedInput-root": {
																		borderRadius: "8px",
																	},
																	"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																		borderColor: setMobileButttonBackColor(),
																	},
																	"& .MuiInputBase-input": {
																		color: setMobileTextColor(),
																		fontFamily:
																			localStorage.getItem("lang") === "ar" ||
																				localStorage.getItem("lang") === "fa"
																				? "Almarai"
																				: "Roboto",
																	},
																	"& .MuiInputLabel-root": {
																		color: setMobileTextColor(),
																	},
																	"& .MuiFormHelperText-root": {
																		color: "#f44336",
																	},
																}}
															/>
														</div>
														<input hidden={true} name="address_id" id="address_id" value={selectedPlace?.id || ""} className="m-top-12 p-24 rounded-3" />
													</>
												)}



												{/* Order Details Section */}
												<div
													className="m-top-12 p-24 rounded-3"
													style={{
														border: `1px solid ${setMobileCardBorderColor()}`,
														backgroundColor: setMobileCardColor(),
														borderRadius: "12px",
														boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
														marginBottom: "16px",
													}}
												>
													<label
														className="font-size-14 mb-1 sub-font"
														style={{
															color: setMobileTextColor(),
															display: "flex",
															alignItems: "center",
															fontWeight: 500,
														}}
													>
														<DescriptionOutlined
															className={`${localStorage.getItem("lang") === "ar" ||
																localStorage.getItem("lang") === "fa"
																? "ms-2"
																: "me-2"
																}`}
															style={{
																color: setMobileButttonBackColor(),
															}}
															fontSize="large"
														/>
														{t("Order details")}
													</label>
													{values?.items?.map((order) => (
														<Order
															key={order.index}
															order={order}
															handleOpenToast={handleOpenToast}
															currency={currencySymbol}
															tableQr={tableQr}
															tableName={tableName}
															refetch={refetchBasket}
														/>
													))}
												</div>

												{/* Payment Details Section */}
												<div
													className="m-top-12 p-24 rounded-3"
													style={{
														border: `1px solid ${setMobileCardBorderColor()}`,
														backgroundColor: setMobileCardColor(),
														borderRadius: "12px",
														boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
														marginBottom: "16px",
													}}
												>
													<label
														className="font-size-14 mb-1 sub-font"
														style={{
															color: setMobileTextColor(),
															display: "flex",
															alignItems: "center",
															fontWeight: 500,
														}}
													>
														<DescriptionOutlined
															className={`${localStorage.getItem("lang") === "ar" ||
																localStorage.getItem("lang") === "fa"
																? "ms-2"
																: "me-2"
																}`}
															style={{
																color: setMobileButttonBackColor(),
															}}
															fontSize="large"
														/>
														{t("Payment details")}
													</label>
													<div className="m-top-12">
														<p
															className="d-flex justify-content-between sub-font"
															style={{
																color: setMobileTextColor(),
																margin: "12px 0",
															}}
														>
															<span className="font-size-16">
																{t("Subtotal")}
															</span>
															<span className="font-size-16">
																{values.total}
																<span className="font-size-16 mx-2">
																	{currencySymbol === "SAR" ? (
																		<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																	) : (
																		currencySymbol
																	)}
																</span>
															</span>
														</p>
														{values?.tax && (
															<p
																className="d-flex justify-content-between sub-font"
																style={{
																	color: setMobileTextColor(),
																	margin: "12px 0",
																}}
															>
																<span className="font-size-16">{t("Tax")}</span>
																<span className="font-size-16">
																	{values.tax}
																	<span className="font-size-16 mx-2">
																		{currencySymbol === "SAR" ? (
																			<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																		) : (
																			currencySymbol
																		)}
																	</span>
																</span>
															</p>
														)}

														{values?.tax_admin > 0 && (
															<p
																className="d-flex justify-content-between sub-font"
																style={{
																	color: setMobileTextColor(),
																	margin: "12px 0",
																}}
															>
																<span className="font-size-16">{t("Admin tax")}</span>
																<span className="font-size-16">
																	{values?.tax_admin}
																	<span className="font-size-16 mx-2">
																		{currencySymbol === "SAR" ? (
																			<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																		) : (
																			currencySymbol
																		)}
																	</span>
																</span>
															</p>
														)}

														{isDeliveryFlag && allTreeData?.details?.is_delivery_active && (
															<p
																className="d-flex justify-content-between sub-font"
																style={{
																	color: setMobileTextColor(),
																	margin: "12px 0",
																}}
															>
																<span className="font-size-16">
																	{t("Delivery Fees")}
																</span>
																<span className="font-size-16">
																	{calcDeliveryFeesValue || allTreeData?.details?.delivery_fees || 0}
																	<span className="font-size-16 mx-2">
																		{currencySymbol === "SAR" ? (
																			<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																		) : (
																			currencySymbol
																		)}
																	</span>
																</span>
															</p>
														)}
													</div>
													<div style={{ borderTop: `1px solid ${setMobileCardBorderColor()}`, margin: "16px 0", paddingTop: "16px" }}>
														<p
															className="d-flex justify-content-between head-font"
															style={{
																color: setMobileTextColor(),
																margin: "12px 0",
															}}
														>
															<span className="font-size-18" style={{ fontWeight: 600 }}>{t("Total")}</span>
															<span className="font-size-18" style={{
																color: setMobileButttonBackColor(),
																fontWeight: 600,
															}}>
																{isDeliveryFlag ? Number(values.final_total_without_delivery_fees) + Number(calcDeliveryFeesValue) : Number(values.final_total_without_delivery_fees)}
																<span className="font-size-18 mx-2">
																	{currencySymbol === "SAR" ? (
																		<img width={20} height={20} src={SARIconThemeColor()} className="mr-1" />
																	) : (
																		currencySymbol
																	)}
																</span>
															</span>
														</p>
														<p
															className="d-flex justify-content-end sub-font"
															style={{
																color: setMobileTextColor(),
																opacity: 0.8,
																fontSize: "14px",
															}}
														>
															<span>
																{t("Total plus VAT")}
															</span>
														</p>
													</div>
												</div>

												{/* Payment Method (SA only) */}
												{isSA && (
													<div
														className="m-top-12 p-24 rounded-3"
														style={{
															backgroundColor: setMobileCardColor(),
															borderRadius: "12px",
															boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
															marginBottom: "16px",
														}}
													>
														<TextField
															select
															id="payment_method"
															required={isDeliveryFlag}
															name="payment_method"
															label={t("Payment method")}
															value={payment_method}
															onChange={(e) => {
																setFieldValue("payment_method", e.target.value);
																setPaymentMethod(e.target.value);
															}}
															className="form-control rounded-2 sub-font"
															size="small"
															fullWidth
															sx={{
																backgroundColor: setMobileCardColor(),
																"& .MuiOutlinedInput-root": {
																	borderRadius: "8px",
																},
																"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																	borderColor: setMobileButttonBackColor(),
																},
																"& .MuiInputBase-input": {
																	color: setMobileTextColor(),
																	fontFamily:
																		localStorage.getItem("lang") === "ar" ||
																			localStorage.getItem("lang") === "fa"
																			? "Almarai"
																			: "Roboto",
																},
																"& .MuiInputLabel-root": {
																	color: setMobileTextColor(),
																},
																"& .MuiInputLabel-root.Mui-focused": {
																	color: setMobileButttonBackColor(),
																},
															}}
														>


															{allTreeData?.details?.is_online_payment_active && (
																isDineInFlag && allTreeData?.details?.is_dinein_active ?
																	allTreeData?.details?.is_dinein_online_payment_active && (
																		<MenuItem
																			key={'ONL'}
																			value={'ONL'}
																			sx={{
																				'&:hover': {
																					backgroundColor: setMobileButttonBackColor() + '20',
																				}
																			}}
																		>
																			{t("PAY ONLINE")}
																		</MenuItem>
																	)
																	: (
																		<MenuItem
																			key={'ONL'}
																			value={'ONL'}
																			sx={{
																				'&:hover': {
																					backgroundColor: setMobileButttonBackColor() + '20',
																				}
																			}}
																		>
																			{t("PAY ONLINE")}
																		</MenuItem>
																	)
															)}

															<MenuItem
																disabled
																key={'Cash'}
																value={'Cash'}
																sx={{
																	'&:hover': {
																		backgroundColor: setMobileButttonBackColor() + '20',
																	}
																}}
															>
																{t("Cash")}
															</MenuItem>
														</TextField>
													</div>
												)}

												{/* Order Notes Section */}
												<div
													className="m-top-12 p-24 rounded-3"
													style={{
														border: `1px solid ${setMobileCardBorderColor()}`,
														backgroundColor: setMobileCardColor(),
														borderRadius: "12px",
														boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
														marginBottom: "70px",
													}}
												>
													<label
														htmlFor="note"
														className="font-size-14 mb-1 sub-font"
														style={{
															color: setMobileTextColor(),
															fontWeight: 500,
														}}
													>
														{t("Note")}
													</label>
													<TextField
														id="note"
														name="note"
														type="note"
														variant="outlined"
														value={orderNote}
														onChange={(e) => {
															setFieldValue("note", e.target.value);
															setOrderNote(e.target.value);
														}}
														placeholder={t("Enter your note")}
														helperText={errors.note && errors.note}
														className="form-control rounded-2 sub-font"
														error={errors.note}
														size="small"
														fullWidth
														multiline
														rows={3}
														sx={{
															backgroundColor: setMobileCardColor(),
															minWidth: 300,
															marginTop: "12px",
															"& .MuiOutlinedInput-root": {
																borderRadius: "8px",
															},
															"& .MuiOutlinedInput-notchedOutline": {
																borderColor: setMobileCardBorderColor(),
															},
															"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
																borderColor: setMobileButttonBackColor(),
															},
															"& .MuiInputBase-input": {
																color: setMobileTextColor(),
																fontFamily:
																	localStorage.getItem("lang") === "ar" ||
																		localStorage.getItem("lang") === "fa"
																		? "Almarai"
																		: "Roboto",
															},
															"& .MuiInputLabel-root": {
																color: setMobileTextColor(),
															},
															"& .MuiFormHelperText-root": {
																color: "#f44336",
															},
														}}
													/>
												</div>

												{/* Submit Button */}
												{(!allTreeData?.details?.order_ability && !allTreeData?.details?.whatsapp) || (values?.length === 0 || basketData?.data?.data?.length === 0) ? null : (
													<div
														className="mt-2 send-order text-center btn d-block"
														style={{
															backgroundColor: setMobileButttonBackColor(),
															color: setMobileTextColor(),
															width: divWidth,
															borderRadius: "12px",
															padding: "5px",
															boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
															zIndex: 100,
														}}
													>
														{isLoadingOrder ? (
															<Button
																className="button-height-sm head-font"
																variant="text"
																fullWidth={true}
																style={{
																	backgroundColor: "transparent",
																	color: setMobileTextColor(),
																}}
															>
																<CircularProgress
																	style={{ color: setMobileTextColor() }}
																	className="mx-2"
																	size={24}
																/>{" "}
																<span>{t("Loading...")}</span>
															</Button>
														) : (
															<Button
																className="w-100 head-font"
																type="submit"
																style={{
																	color: setMobileTextColor(),
																	fontWeight: 600,
																	fontSize: "16px",
																	letterSpacing: "0.5px",
																	'&:hover': {
																		backgroundColor: setMobileButttonBackColor() + 'CC',
																	}
																}}
															>
																{t("Send order")}
															</Button>
														)}
													</div>
												)}
											</Form>
										)}
									</Formik>
								</div>
							</div>
						</div>
					</div>

					<Toast
						open={toastSettings.open}
						message={toastSettings.message}
						resetToast={handleCloseToast}
						success={toastSettings.success}
					/>
				</div>

				<LoadingTreeDataDialog
					openTreeDialogFlag={loadingTreeDialog}
					tableName={tableName}
					tableQr={tableQr}
				/>

				<Dialog
					className="alignByLang"
					fullWidth
					open={openDialog}
					onClose={closePaymentDialog}
				>
					<DialogTitle className="head-font">{t("Payment Method")}</DialogTitle>
					<DialogContent>
						<FormControl fullWidth>
							<InputLabel className="sub-font" style={{ marginTop: 5 }}>
								{t("Payment Method")}
							</InputLabel>
							<Select
								value={selectedGateway}
								onChange={handleGatewaySelect}
								label={t("Payment Method")}
							>
								<MenuItem className="sub-font" value="mada">{t("mada")}</MenuItem>
							</Select>
						</FormControl>

						{selectedGateway && (
							<div style={{ marginTop: "20px", textAlign: "center" }}>
								<img
									src={gatewayImage}
									alt="Gateway"

									style={{ width: "auto", height: "auto", maxWidth: "100%", maxHeight: "200px", objectFit: "contain" }}
								/>
							</div>
						)}
					</DialogContent>

					<DialogActions>
						<Button className="head-font" onClick={closePaymentDialog} color="secondary">
							{t("Cancel")}
						</Button>
						<Button
							className="head-font"
							onClick={handlePayment}
							color="primary"
							disabled={!selectedGateway}
						>
							{t("Continue")}
						</Button>
					</DialogActions>
				</Dialog>

				<LoginComponent
					open={dialogOpen}
					handleCloseDialog={handleCloseDialog}
					tableQr={tableQr}
					tableName={tableName}
					onVerificationSuccess={handleVerificationSuccess}
					is_from={2}
				/>

				<DeliveryDialog
					open={deliveryDialogOpen}
					savedPlaces={savedPlaces}
					isLoadingSavedPlaces={isLoadingSavedPlaces}
					openLocationFormDailog={() => setOpenLocationFormDialog(true)}
					onClose={() => setDeliveryDialogOpen(false)}
					onSelect={handleOptionSelect}
					onSelectPlace={handleSelectPlace}
					openDeleteLocationDialog={handleOpenDeleteLocationDialog}
				/>

				<Dialog
					className="alignByLang"
					open={mode === "current"}
					onClose={() => setMode(null)}
					fullWidth
					maxWidth="sm"
				>
					<DialogContent sx={{
						backgroundColor: setMobileBackColor(),
						color: setMobileTextColor(),
						border: `1px solid ${setMobileCardBorderColor()}`
					}}>
						<CurrentLocationMap
							openLocationFormDailog={() => setOpenLocationFormDialog(true)}
							closeLocationFormDailog={() => handleCloseFormDialog()}
							latlangVal={(latlang) => setLatLangVal(latlang)}
							closeMapModal={() => setMode(null)}
							updateLocationFormData={(pickupMapAddress) => updateLocationFormData(pickupMapAddress)}
						/>
					</DialogContent>
				</Dialog>

				<Dialog
					className="alignByLang"
					open={mode === "new"}
					onClose={() => setMode(null)}
					fullWidth
					maxWidth="sm"
				>
					<DialogContent className="alignByLang" sx={{
						backgroundColor: setMobileBackColor(),
						color: setMobileTextColor(),
						border: `1px solid ${setMobileCardBorderColor()}`
					}}>
						<NewLocationPicker
							openLocationFormDailog={() => setOpenLocationFormDialog(true)}
							closeLocationFormDailog={() => handleCloseFormDialog()}
							latlangVal={(latlang) => setLatLangVal(latlang)}
							closeMapModal={() => setMode(null)}
							updateLocationFormData={(pickupMapAddress) => updateLocationFormData(pickupMapAddress)}
						/>
					</DialogContent>
				</Dialog>

				<Dialog
					className="alignByLang"
					disableEscapeKeyDown
					open={openLocationFormDialog}
					onClose={() => handleCloseFormDialog()}
					TransitionComponent={Transition}
					fullWidth
					maxWidth="sm"
					sx={{
						backgroundColor: setMobileBackColor(),
						color: setMobileTextColor(),
						border: `1px solid ${setMobileCardBorderColor()}`,
					}}
					PaperProps={{
						style: {
							backgroundColor: setMobileBackColor(),
							color: setMobileTextColor(),
							border: `1px solid ${setMobileCardBorderColor()}`,
						},
					}}
				>
					<DialogTitle className="alignByLang head-font" >🏠 {t("Enter Location Details")}</DialogTitle>
					<DialogContent dividers className="alignByLang sub-font">
						<Box className="alignByLang" display="flex" flexDirection="column" gap={2} mt={1}>
							<TextField
								name="title"
								value={locationFormData.title}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("LocationName")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<TitleOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>
							<TextField
								name="street"
								value={locationFormData.street || ""}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("Street Name")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<LocationOnOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>
							<TextField
								name="unit_number"
								value={locationFormData.unit_number}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("Unit No")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<HouseOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>
							<TextField
								name="floor_number"
								value={locationFormData.floor_number}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("Floor No")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<StairsOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>

							<TextField
								name="apartment_number"
								value={locationFormData.apartment_number}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("Flat No")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<ApartmentOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>

							<TextField
								name="country"
								value={locationFormData.country}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("country")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<FlagOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>

							<TextField
								name="city"
								value={locationFormData.city}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("city")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<LocationCity sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>

							<TextField
								name="state"
								value={locationFormData.state}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("state")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<PinDropOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>

							<TextField
								name="postcode"
								value={locationFormData.postcode}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("postal code")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<LocalPostOfficeOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>

							<TextField
								name="province"
								value={locationFormData.province}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("province")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<FlagOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>

							<TextField
								name="suburb"
								value={locationFormData.suburb}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("suburb")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<HomeOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>

							<TextField
								name="description"
								value={locationFormData.description}
								onChange={handleLocationFormInputChange}
								fullWidth
								placeholder={t("Address description")}
								InputProps={{
									startAdornment: (
										<InputAdornment position="start">
											<DescriptionOutlined sx={{ color: setMobileTextColor() }} />
										</InputAdornment>
									),
								}}
								sx={{
									color: setMobileTextColor(),
									backgroundColor: setMobileCardColor(),
									"& .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileCardBorderColor(),
									},
									"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
										borderColor: setMobileButttonBackColor(),
									},
									"& .MuiInputBase-input": {
										color: setMobileTextColor(),
										textAlign: "center",
										"&::placeholder": {
											color: setMobileTextColor(),
											opacity: 0.7,
											fontFamily:
												localStorage.getItem("lang") === "ar" ||
													localStorage.getItem("lang") === "fa"
													? "Almarai"
													: "Roboto, sans-serif",
										},
									},
								}}
							/>
						</Box>
					</DialogContent>
					<DialogActions className="alignByLang" sx={{ flexDirection: "row", justifyContent: "space-around" }}>
						<Button
							className="head-font"
							sx={{
								backgroundColor: setMobileBackColor(),
								color: setMobileTextColor(),
								border: `1px solid ${setMobileCardBorderColor()}`,
								"&.Mui-disabled": {
									color: setMobileTextColor(),
								}
							}}
							onClick={() => handleCloseFormDialog()} >
							{t("Cancel")}
						</Button>
						<LoadingButton
							className="head-font"
							sx={{
								backgroundColor: setMobileBackColor(),
								color: setMobileTextColor(),
								border: `1px solid ${setMobileCardBorderColor()}`,
								"&.Mui-disabled": {
									color: setMobileTextColor(),
								}
							}}
							onClick={isEditDelivery ? handleUpdateLocation : handleSaveLocation}
							loading={isProcessLoading}
							disabled={
								!locationFormData.title ||
								!locationFormData.street ||
								!locationFormData.unit_number ||
								!locationFormData.floor_number ||
								!locationFormData.apartment_number ||
								isProcessLoading
							}
						>
							{isEditDelivery ? t("Update Location") : t("Save Location")}
						</LoadingButton>
					</DialogActions>
				</Dialog>

				<DeleteLocationDialog
					onDeleteDeleteLocationDialog={handleDeleteLocation}
					deleteLocationDialogOpen={deleteLocationDialogOpen}
					onCloseDeleteLocationDialog={() => setDeleteLocationDialogOpen(false)}
				/>

				{/* Empty Cart Confirmation Dialog */}
				<Dialog
					open={confirmEmptyDialog}
					onClose={() => setConfirmEmptyDialog(false)}
					PaperProps={{
						sx: {
							backgroundColor: setMobileCardColor(),
							color: setMobileTextColor(),
							borderRadius: "12px",
							padding: "16px",
							minWidth: "300px"
						}
					}}
				>
					<DialogTitle className="head-font" sx={{ textAlign: "center" }}>
						{t("Empty Cart?")}
					</DialogTitle>
					<DialogContent>
						<Typography className="sub-font" sx={{ textAlign: "center" }}>
							{t("Are you sure you want to remove all items from your cart?")}
						</Typography>
					</DialogContent>
					<DialogActions sx={{ justifyContent: "center", gap: 2, paddingBottom: "16px" }}>
						<Button
							onClick={() => setConfirmEmptyDialog(false)}
							sx={{
								color: setMobileTextColor(),
								border: `1px solid ${setMobileCardBorderColor()}`,
								borderRadius: "8px",
								padding: "8px 16px",
								textTransform: "none",
								minWidth: "100px"
							}}
						>
							{t("Cancel")}
						</Button>
						<Button
							onClick={() => {
								emptyOrderBasket().then(() => {
									handleOpenToast(t("Cart has been emptied"), true);
									handleBack();
								});

								setConfirmEmptyDialog(false);
							}}
							sx={{
								backgroundColor: "#f44336",
								color: "white",
								borderRadius: "8px",
								padding: "8px 16px",
								textTransform: "none",
								minWidth: "100px",
								'&:hover': {
									backgroundColor: "#d32f2f"
								}
							}}
						>
							{t("Empty")}
						</Button>
					</DialogActions>
				</Dialog>
			</Container>
			<BottomNavBar qr={tableQr} qrName={tableName} saveCartState={() => handleSaveCartState()} />
		</div>
	);
};

export default Cart;
